<template>
  <div v-if="informationMouvement">
  <div class="is-marginless is-paddingless section">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('enCoursTiers.lettrages.title')}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" v-if="tiersId"></app-breadcrumb>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons ">
            <a class="button" @click="exitLettrage()">
              {{ $t('enCoursTiers.lettrages.annuler') }}
            </a>
            <a class="button is-addOrEdit" @click="saveLettrageAndExit()">
              {{ $t('enCoursTiers.lettrages.valider') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
    <br>
    <error-msg-component :messages="messages"
                          :error="error"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          :title="'editionClient.problemOccurred'"
                          :withEmplyFields="true"
                          @close="error = $event"/>
    <form @submit.prevent="filter = filterInput" class="columns">
      <div class="column is-3">
        <b-field>
          <b-input :placeholder="$t('listeCommandes.actions.search')"
                   type="search"
                   icon="magnify"
                   class="inputSearch"
                   v-model="filterInput">
          </b-input>
          <p class="control">
            <button class="button is-primary">
              {{ $t('listeCommandes.actions.search')}}
            </button>
          </p>
        </b-field>
      </div>
    </form>
    <b-field>
      <div class="column is-3 card">
        <span>{{ this.$t('enCoursTiers.lettrages.resteALettrer') }}</span>
        <div class="is-pulled-right">
          <span>
            {{ getSolde | formatDevise }}
          </span>
        </div>
      </div>
      <div class="column is-narrow has-text-weight-bold mgl-10px is-paddingless
      mgt-10px">
        <router-link-blank v-if="getNameRoute(informationMouvement) !== null"
          :to="getNameRoute(informationMouvement)"
          :message="informationMouvement.libelle"></router-link-blank>
        <span v-else>{{ informationMouvement.libelle }}</span>
      </div>
      <div class="column is-narrow has-text-weight-bold is-paddingless mgt-10px">
        &nbsp;
        <span>{{ this.$t('enCoursTiers.lettrages.du')}}</span>
        <span>{{ ' ' }}</span>
        <span>{{ informationMouvement.dateMouvement | formatDate}}</span>
        <span>{{ this.$t('enCoursTiers.lettrages.dun') }}</span>
        <span>{{ this.$t('enCoursTiers.lettrages.montantDe') }}</span>
        <span v-if="isRemiseBancaire">
          <span>{{ informationMouvement.credit - informationMouvement.debit | formatDevise}}</span>
        </span>
        <span v-else>
          <span v-if="informationMouvement.credit > informationMouvement.debit">
            {{ informationMouvement.credit | formatDevise}}
          </span>
          <span v-else>{{ informationMouvement.debit | formatDevise}}</span>
        </span>
      </div>
    </b-field>
    <br>
    <v-client-table
        :data="detailMouvementFilter"
        :columns="columns"
        :options="options"
        ref="tableLettrageEnCours">
      <template slot='afterTable'>
          <table-items-in-view @input="$refs.tableLettrageEnCours.setLimit($event)"/>
      </template>
      <div slot="facture" slot-scope="props" class="is-pulled-left">
        <router-link-blank v-if="getNameRoute(props.row) !== null"
          :to="getNameRoute(props.row)"
          :message="props.row.libelle"></router-link-blank>
        <span v-else>{{ props.row.libelle }}</span>
      </div>
      <div slot="dateEcheance" slot-scope="props" class="is-pulled-left">
        {{ props.row.dateEcheance }}
      </div>
      <div slot="montant" slot-scope="props" class="is-pulled-right">
        {{ props.row.montant | formatDevise}}
      </div>
      <div slot="montantRestant" slot-scope="props" class="is-pulled-right">
        {{ props.row.montantRestant | formatDevise}}
      </div>
      <div  slot="assign"
            slot-scope="props"
            @click="assignAmount(props.row)"
            class="has-text-centered">
        <b-icon icon="arrow-expand-right"
                type="is-primary"
                class="is-cursor-pointer mgt-5px">
        </b-icon>
      </div>
      <div slot="inputLetterage" slot-scope="props" class="right">
        <input-currency v-model="props.row.inputLetterage" :value="props.row.inputLetterage"
                        isNumber="true" :decimals="2" @input="calculateSolde(props.row)"
                        :disabled="isEscompte(props.row)">
        </input-currency>
      </div>
      <div slot="solde" slot-scope="props" class="is-pulled-right">
        {{ props.row.solde | formatDevise}}
      </div>
    </v-client-table>
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { getAll, get } from '@/api/mouvementClient/index';
import inputCurrency from '@/components/general/inputCurrency';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import { LETTRE_PARTIELLEMENT, NON_LETTRE } from '@/configuration/lettrageConf';
import messageErreur from '@/services/general/messageErreur';
import preparationDesLettrages from '@/services/lettrages/preparationDesLettrages';
import { sauvegarde } from '@/api/lettrage/index';
import miseEnFormeDuTableauDesEcheances from '@/services/remiseBancaire/miseEnFormeTableauLettrages';
import genererTableauDesLettragesModification from '@/services/remiseBancaire/initLettragesModification';
import validationReglement from '@/services/reglement/validation/validationReglement';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import validationGeneral from '@/services/validation/validation';
import TableItemsInView from '@/components/general/TableItemsInView';

const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'm_lettrageEnCoursTiers',
  data() {
    return {
      dataTable: [],
      informationMouvement: null,
      tiersId: null,
      filter: '',
      filterInput: '',
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    inputCurrency,
    routerLinkBlank,
    errorMsgComponent,
    TableItemsInView,
  },
  methods: {
    loadError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationReglement(response, this.messages);
      validationGeneral(this.$i18n, response, this.champsVide,
        this.messages, this.messagesChampsVide);
      this.error = true;
    },
    async saveLettrageAndExit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const allLettrages = preparationDesLettrages(this.dataTable, this.$route.params.id);
        if (allLettrages.lettrages.length > 0) {
          await sauvegarde(allLettrages);
        }
        this.exitLettrage();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
    },
    getNameRoute(informationData) {
      switch (informationData.typeDePiece) {
        case mouvementClientConf.FACTURE:
        case mouvementClientConf.AVOIR:
        case mouvementClientConf.ACOMPTE:
          return {
            name: 'c.bodac.factures',
            params: {
              id: informationData.idFacture === undefined ? informationData.factureId
                : informationData.idFacture,
            },
          };
        case mouvementClientConf.REGLEMENT:
          return {
            name: 'c.bodac.remises_bancaires',
            params: { id: informationData.remiseBancaireId },
          };
        case mouvementClientConf.OD:
          return {
            name: 'c.comptabilite.operation_diverse',
            params: { id: informationData.operationDiverseId },
          };
        case mouvementClientConf.CHARGE:
        case mouvementClientConf.AVOIR_DE_CHARGE:
          return {
            name: 'c.baux.facture_achat',
            params: {
              id: informationData.idFacture === undefined ? informationData.factureId
                : informationData.idFacture,
            },
          };
        case mouvementClientConf.PAIEMENT:
          return {
            name: 'c.baux.lot_paiement',
            params: { id: informationData.remiseBancaireId },
          };
        default: return null;
      }
    },
    assignAmount(row) {
      if (this.getSolde <= 0) return;
      if (this.getSolde + row.inputLetterage < row.montantRestant) {
        row.inputLetterage += this.getSolde;
      } else {
        row.inputLetterage = row.montantRestant;
      }
      this.calculateSolde(row);
    },
    async getMouvement(query) {
      const loadingComponent = this.$buefy.loading.open();
      let mouvement = [];
      try {
        const objectFilter = {
          query: query,
          MaxResultCount: 9999,
          SkipCount: 0,
          societeId: this.societeActiveId,
        };
        const response = await getAll(objectFilter);
        const allMouvement = response.data.result.items;
        mouvement = await miseEnFormeDuTableauDesEcheances(allMouvement);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
      return mouvement;
    },
    calculateSolde(echeance) {
      if (echeance.inputLetterage === null) {
        echeance.inputLetterage = 0;
        echeance.solde = echeance.soldeSave;
      }
      if (echeance.inputLetterage >= echeance.soldeSave) {
        echeance.inputLetterage = echeance.soldeSave;
        echeance.solde = 0;
      } else {
        echeance.solde = echeance.soldeSave - echeance.inputLetterage;
      }
      const idx = this.dataTable.findIndex(el => el.idEcheance === echeance.idEcheance);
      this.$set(this.dataTable, idx, echeance);
    },
    exitLettrage() {
      this.$router.go(-1);
    },
    async loadAndMiseEnFormeMouvement(infoMouvement) {
      const parameters = {
        etatLettrage: [NON_LETTRE, LETTRE_PARTIELLEMENT],
        debit: infoMouvement.credit > infoMouvement.debit,
        brouillard: false,
        tiersId: this.tiersId,
        societeId: this.societeActiveId,
      };
      const mouvement = await this.getMouvement(parameters);
      this.dataTable = await genererTableauDesLettragesModification(infoMouvement.lettrages,
        infoMouvement.id, mouvement);
    },
    isEscompte(mouvementClient) {
      if (mouvementClient === null) return false;
      return mouvementClient.typeDePiece === mouvementClientConf.ESCOMPTE;
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    isRemiseBancaire() {
      return this.informationMouvement.idFacture === null
        || this.informationMouvement.factureId === null;
    },
    getSolde() {
      let solde = this.informationMouvement.credit > this.informationMouvement.debit
        ? this.informationMouvement.credit : this.informationMouvement.debit;
      this.dataTable.forEach((mouvement) => {
        solde -= mouvement.inputLetterage;
      });
      return solde;
    },
    breadcrumb() {
      const output = [
        { title: this.$t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        {
          title: this.$route.params.isFromDetailClient ? this.$t('listeClients.title') : this.$i18n.t('detailBailleur.breadcrumb.liste'),
          route: { name: this.$route.params.isFromDetailClient ? 'l.bodac.clients/contacts-clients' : 'l.baux.bailleur' },
          isActive: false,
        },
        {
          title: this.$route.params.isFromDetailClient
            ? this.$t('detailClient.title', { nomCommercial: this.informationMouvement?.tiers?.nomCommercial })
            : this.$i18n.t('detailBailleur.breadcrumb.detail'),
          route: {
            name: this.$route.params.isFromDetailClient ? 'c.bodac.clients/contacts-enCours' : 'c.baux.bailleur',
            params: { id: this.tiersId },
          },
          isActive: false,
        },
        { title: this.$t('enCoursTiers.lettrages.title'), route: null, isActive: true },
      ];
      return output;
    },
    columns() {
      return [
        'facture', 'dateEcheance', 'montant', 'montantRestant', 'assign', 'inputLetterage', 'solde',
      ];
    },
    detailMouvementFilter() {
      return this.dataTable.filter(item => {
        return item.libelle && item.libelle.toLowerCase().includes(this.filter.toLowerCase());
      });
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          facture: this.$t('remiseBancaire.ajoutReglement.facture'),
          dateEcheance: this.$t('remiseBancaire.ajoutReglement.dateEcheance'),
          montant: this.$t('remiseBancaire.ajoutReglement.montant'),
          montantRestant: this.$t('remiseBancaire.ajoutReglement.montantRestantTtc'),
          inputLetterage: this.$t('remiseBancaire.ajoutReglement.inputLetterage'),
          solde: this.$t('remiseBancaire.ajoutReglement.solde'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        sortable: [
          'facture', 'dateEcheance', 'montant', 'montantRestant',
        ],
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const result = await get(this.$route.params.id);
      this.informationMouvement = result.data.result;
      this.tiersId = result.data.result.tiersId;
      this.loadAndMiseEnFormeMouvement(this.informationMouvement);
      loadingComponent.close();
    } catch (e) {
      if (e.response.data.error) {
        this.loadError(e.response);
      } else {
        messageErreur(this.$i18n);
      }
      loadingComponent.close();
      throw (e);
    }
    this.setInformationPage(this.$t('pageGeneral.modification', { item: this.informationMouvement.tiers.nomCommercial }));
  },
};
</script>

<style scoped>

</style>
